<ng-template #loading>
   <lib-loading></lib-loading>
</ng-template>

<ng-template #invalid>
   <div id="hawbWarning" class="common-pad1em common-tacenter">Unable to locate HAWB {{hawb}}</div>
</ng-template>

<ng-container *ngIf="hawb; else invalid">
   <ng-container *ngIf="mode === 'shipment'">
      <ng-container *ngIf="shipment$ | async as shipment; else loading">
         <ng-container *ngIf="shipment; else invalid">
            <div class="shipment-details">
               <h2 color="primary" id="shipmentDetails">Shipment Details</h2>
   
               <div class="hawb-row">
                  <div class="service-label" id="hawb">HAWB #{{shipment.hawb}}</div>
                  <span id="delayedChip" class="delayed-chip" *ngIf="isShipmentDelayed( shipment )">
                     <span class="dot"></span>
                     <span class="label">Delayed</span>
                  </span>
               </div>

               <div id="delayBanner" class="delay-banner" *ngIf="isShipmentDelayed( shipment )">
                  <span class="delay-banner-icon">
                     <mat-icon id="delayBannerIcon" aria-hidden="true">warning</mat-icon>
                  </span>
                  <span id="delayBannerTitle" class="delay-banner-title">Shipment delayed</span>
                  <span id="delayBannerReason" class="delay-banner-reason" *ngIf="getDelayReason( shipment )">&middot; {{getDelayReason( shipment )}}</span>
               </div>

               <div class="summary">
                  <div class="list summary-details">
                     <ng-container *ngIf="shipment.servicelevel">
                        <header id="serviceLevelLabel" color="primary">Service Level</header>
                        <span id="summaryServiceLevel"> {{shipment.servicelevel}}<br/></span>
                     </ng-container>
   
                     <ng-container *ngIf="items$ | async as items">
                        <header id="summaryTotalPiecesLabel" color="primary">Total Pieces</header>
                        <span id="summaryTotalPieces"> {{items | total : 'pieces' | number}}<br/></span>
   
                        <header id="summaryTotalWeightLabel" color="primary">Total Weight</header>
                        <span id="summaryTotalWeight"> {{items | totaldualweight }}<br/></span>
   
                        <ng-container *ngIf="items | totalvolume">
                           <header id="summaryVolumeLabel" color="primary">Volume</header>
                           <span id="summaryVolume"> {{items | totaldualvolume }}<br/></span>
                        </ng-container>
                     </ng-container>
   
                     <ng-container *ngIf="getBillingPartyRef( shipment ) as ref">
                        <header id="summaryReferenceLabel" color="primary">Ref #</header>
                        <span id="summaryReference">
                           <ng-container *ngIf="ref.type">{{ref.type | uppercase}} - </ng-container>
                           {{ref.data}}<br/>
                        </span>
                     </ng-container>
                  </div>
   
                  <div id="shipperSummary" class="summary-shipper">
                     <b color="primary">Shipper</b><br/>
                     {{shipment.shipper.name}}, {{shipment.shipper.city}}<br/>
                     Pickup Date
                     <ng-container id="pdatefrom" *ngIf="shipment.pdatefrom">{{shipment.pdatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="shipment.pdatefrom && shipment.pdateto"> - </ng-container>
                     <ng-container id="pdateto" *ngIf="shipment.pdateto">{{shipment.pdateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Pickup Time
                     <ng-container id="ptimefrom" *ngIf="shipment.ptimefrom">{{shipment.ptimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="shipment.ptimefrom && shipment.ptimeto"> - </ng-container>
                     <ng-container id="ptimeto" *ngIf="shipment.ptimeto">{{shipment.ptimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <div id="consigneeSummary" class="summary-consignee">
                     <b color="primary">Consignee</b><br/>
                     {{shipment.consignee.name}}, {{shipment.consignee.city}}<br/>
                     Delivery Date
                     <ng-container id="ddatefrom" *ngIf="shipment.ddatefrom">{{shipment.ddatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="shipment.ddatefrom && shipment.ddateto"> - </ng-container>
                     <ng-container id="ddateto" *ngIf="shipment.ddateto">{{shipment.ddateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Delivery Time
                     <ng-container id="dtimefrom" *ngIf="shipment.dtimefrom">{{shipment.dtimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="shipment.dtimefrom && shipment.dtimeto"> - </ng-container>
                     <ng-container id="dtimeto" *ngIf="shipment.dtimeto">{{shipment.dtimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <ng-container *ngIf="shipment.station as station">
                     <div id="stationSummary" class="summary-station">
                        <b color="primary">Station</b><br/>
                        {{station.name}}<br/>
                        {{station.address1}}<br/>
                        <ng-container id="address2" *ngIf="station.address2">{{station.address2}}<br/></ng-container>
                        {{station.city}}, {{station.state}} {{station.postalcode}}<br/>
                        <ng-container id="country" *ngIf="station.country">{{ countries.countryName( station.country ) | async }}<br/></ng-container>
                        <ng-container *ngIf="station.phone || station.email">
   
                        <br/>
                        <ng-container id="phone" *ngIf="station.phone">{{station.phone}}<br/></ng-container>
                        <ng-container id="email" *ngIf="station.email">{{station.email}}<br/></ng-container>
                     </ng-container>
                     </div>
                  </ng-container>

                  <div id="dateSummary" class="summary-dates" *ngIf="shipment.fwq != null && shipment.fwq != ''">
                     <b color="primary">Quotation #</b><br/>
                     <a id="quotation" routerLink="/manage/quotations/{{ shipment.fwq }}">{{ shipment.fwq }}</a><br/>
                  </div>
               </div>
   
               <lib-tracker-line [mode]="[shipment.mode]" [milestoneObj]="shipment.milestones" [plannedMilestonesObj]="shipment.plannedMilestones" [isDelayed]="isShipmentDelayed( shipment )"></lib-tracker-line>
   
               <div class="details">
                  <ng-container *ngIf="shipment.freightBookingDetails?.length > 0; else noFreightBookings">
                     <ng-container *ngFor="let fb of shipment.freightBookingDetails">
                        <mat-expansion-panel class="bordered" expanded>
                        <mat-expansion-panel-header>Booking Details</mat-expansion-panel-header>
                        <!-- Ocean Layout -->
                        <div class="booking-details-grid ocean-grid" *ngIf="shipment.mode === 'ocean'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.origin">
                                 <header color="primary">Origin Port</header>
                                 <span>{{shipment.origin | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.destination">
                                 <header color="primary">Destination Port</header>
                                 <span>{{shipment.destination | uppercase}}</span>
                              </div>
                              <div *ngIf="fb.sailingDate">
                                 <header color="primary">Sailing Date</header>
                                 <span>{{fb.sailingDate}}</span>
                              </div>
                              <div *ngIf="fb.eta">
                                 <header color="primary">Estimated Time of Arrival</header>
                                 <span>{{fb.eta}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="fb.computedContainerNumbers">
                                 <header color="primary">Container Number(s)</header>
                                 <span>{{fb.computedContainerNumbers}}</span>
                              </div>
                              <div *ngIf="fb.computedSealNumbers">
                                 <header color="primary">Seal Number(s)</header>
                                 <span>{{fb.computedSealNumbers}}</span>
                              </div>
                              <div *ngIf="fb.voyage">
                                 <header color="primary">Voyage</header>
                                 <span>{{fb.voyage}}</span>
                              </div>
                              <div *ngIf="fb.vessel">
                                 <header color="primary">Vessel</header>
                                 <span>{{fb.vessel}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- Domestic Layout -->
                        <div class="booking-details-grid domestic-grid" *ngIf="shipment.shipType === 'domestic'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.airportfrom">
                                 <header color="primary">Origin Airport</header>
                                 <span>{{shipment.airportfrom | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.airportto">
                                 <header color="primary">Destination Airport</header>
                                 <span>{{shipment.airportto | uppercase}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- INTL Air Layout -->
                        <div class="booking-details-grid intl-air-grid" *ngIf="shipment.shipType === 'international' && shipment.mode === 'air'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.airportfrom">
                                 <header color="primary">Origin Airport</header>
                                 <span>{{shipment.airportfrom | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.airportto">
                                 <header color="primary">Destination Airport</header>
                                 <span>{{shipment.airportto | uppercase}}</span>
                              </div>
                              <div *ngIf="fb.mawb">
                                 <header color="primary">MAWB</header>
                                 <span><ng-container *ngIf="fb.awbPrefix">{{fb.awbPrefix}}-</ng-container>{{fb.mawb}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- INTL Road Layout -->
                        <div class="booking-details-grid intl-air-grid" *ngIf="shipment.shipType === 'international' && shipment.mode === 'road'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.origin">
                                 <header color="primary">Origin</header>
                                 <span>{{shipment.origin | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.destination">
                                 <header color="primary">Destination</header>
                                 <span>{{shipment.destination | uppercase}}</span>
                              </div>
                           </div>
                        </div>
                     </mat-expansion-panel>
                     </ng-container>
                  </ng-container>
                  <ng-template #noFreightBookings>
                     <mat-expansion-panel id="bookingDetails" class="bordered" expanded>
                        <mat-expansion-panel-header>Booking Details</mat-expansion-panel-header>
                        <!-- Ocean Layout -->
                        <div class="booking-details-grid ocean-grid" *ngIf="shipment.mode === 'ocean'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.origin">
                                 <header color="primary">Origin Port</header>
                                 <span>{{shipment.origin | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.destination">
                                 <header color="primary">Destination Port</header>
                                 <span>{{shipment.destination | uppercase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.allContainerNumbers">
                                 <header color="primary">Container Number(s)</header>
                                 <span>{{shipment.allContainerNumbers}}</span>
                              </div>
                              <div *ngIf="shipment.allSealNumbers">
                                 <header color="primary">Seal Number(s)</header>
                                 <span>{{shipment.allSealNumbers}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- Domestic Layout -->
                        <div class="booking-details-grid domestic-grid" *ngIf="shipment.shipType === 'domestic'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.airportfrom">
                                 <header color="primary">Origin Airport</header>
                                 <span>{{shipment.airportfrom | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.airportto">
                                 <header color="primary">Destination Airport</header>
                                 <span>{{shipment.airportto | uppercase}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- INTL Air Layout -->
                        <div class="booking-details-grid intl-air-grid" *ngIf="shipment.shipType === 'international' && shipment.mode === 'air'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.airportfrom">
                                 <header color="primary">Origin Airport</header>
                                 <span>{{shipment.airportfrom | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.airportto">
                                 <header color="primary">Destination Airport</header>
                                 <span>{{shipment.airportto | uppercase}}</span>
                              </div>
                           </div>
                        </div>
                        <!-- INTL Road Layout -->
                        <div class="booking-details-grid intl-air-grid" *ngIf="shipment.shipType === 'international' && shipment.mode === 'road'">
                           <div class="column">
                              <div *ngIf="shipment.shipType">
                                 <header color="primary">Type</header>
                                 <span>{{shipment.shipType | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.mode">
                                 <header color="primary">Mode</header>
                                 <span>{{shipment.mode | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.trafficDirection">
                                 <header color="primary">Traffic Direction</header>
                                 <span>{{shipment.trafficDirection | titlecase}}</span>
                              </div>
                              <div *ngIf="shipment.movementType">
                                 <header color="primary">Movement Type</header>
                                 <span>{{shipment.movementType.from | titlecase}} to {{shipment.movementType.to | titlecase}}</span>
                              </div>
                           </div>
                           <div class="column">
                              <div *ngIf="shipment.airportfrom">
                                 <header color="primary">Origin Airport</header>
                                 <span>{{shipment.airportfrom | uppercase}}</span>
                              </div>
                              <div *ngIf="shipment.airportto">
                                 <header color="primary">Destination Airport</header>
                                 <span>{{shipment.airportto | uppercase}}</span>
                              </div>
                           </div>
                        </div>
                     </mat-expansion-panel>
                  </ng-template>
   
                  <div id="partyCard" class="party-card">
                     <ng-container *ngFor="let party of [ 'shipper', 'consignee', 'bill_to' ]">
                        <mat-expansion-panel [id]="party+'Party'" [class]="'mat-expansion-panel bordered ' + party" expanded hideToggle *ngIf="shipment[party] as data">
                           <mat-expansion-panel-header>{{party | spacers | titlecase}}</mat-expansion-panel-header>
                           <div id="partyContent" class="content">
                              <div id="partyName">{{data.name}}</div>
                              {{data.address1}}<br/>
                              <ng-container *ngIf="data.address2">{{data.address2}}<br/></ng-container>
                              <ng-container *ngIf="data.address3">{{data.address3}}<br/></ng-container>
                              {{data.city}}, {{data.state}} {{data.postalcode}}<br/>
                              <ng-container *ngIf="data.country">{{ countries.countryName( data.country ) | async }}<br/></ng-container>
                              <br *ngIf="data.phone || data.email" />
                              <ng-container *ngIf="data.phone">{{data.phone}}<br/></ng-container>
                              <ng-container *ngIf="data.email">
                                 <a id="partyEmail" href="mailto:{{data.email}}" color="accent" class="common-tdnone">{{data.email}}<br/></a>
                              </ng-container>
                              <ng-container *ngIf="data.contact as contact">
                                 <br *ngIf="contact.name || contact.phone || contact.email" />
                                 <ng-container *ngIf="contact.name">{{contact.name}}<br/></ng-container>
                                 <ng-container *ngIf="contact.phone">{{contact.phone}}<br/></ng-container>
                                 <ng-container *ngIf="contact.email">
                                    <a id="contactEmail" href="mailto:{{contact.email}}" color="accent" class="common-tdnone">{{contact.email}}</a>
                                 </ng-container>
                              </ng-container>
                           </div>
                        </mat-expansion-panel>
                     </ng-container>
                  </div>
   
                  <mat-expansion-panel id="serviceLevelDates" class="bordered" expanded>
                     <mat-expansion-panel-header>
                        Service Level and Dates
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div id="serviceLevel" *ngIf="shipment.servicelevel">
                           <div>Service Level</div>
                           {{shipment.servicelevel}}
                        </div>
   
                        <div id="incoterms" *ngIf="shipment.incoterms">
                           <div>Incoterms</div>
                           {{shipment.incoterms}}
                        </div>

                        <div id="accessorials" class="accessorials-container" *ngIf="shipment.accessorials && shipment.accessorials.length">
                           <div>Accessorials</div>
                           <span
                             #textContent
                             class="accessorials-text">
                             {{ getAccessorial(shipment.accessorials , expanded) | titlecase}}
                             <span *ngIf="!expanded && showToggle" class="more-toggle" (click)="expanded = true">{{ ' + '+ remainingAccessorials +' More'}}</span>
                           </span>
                         </div>
   
                        <div id="awbType" *ngIf="shipment.awbType">
                           <div>AWB Type</div>
                           {{shipment.awbType}}
                        </div>
   
                        <div id="teu" *ngIf="shipment.teu">
                           <div>Number of TEU</div>
                           {{shipment.teu}}
                        </div>
   
                        <div class="hr"></div>
   
                        <div id="pickupDates" #pickup>
                           <div>Pickup</div>
                           <ng-container *ngIf="shipment.pdatefrom">{{shipment.pdatefrom | date}}</ng-container>
                           <ng-container *ngIf="shipment.pdatefrom && shipment.pdateto"> - </ng-container>
                           <ng-container *ngIf="shipment.pdateto">{{shipment.pdateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="shipment.ptimefrom">{{shipment.ptimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="shipment.ptimefrom && shipment.ptimeto"> - </ng-container>
                           <ng-container *ngIf="shipment.ptimeto">{{shipment.ptimeto | time : 'h:mm A'}}</ng-container>
                        </div>
   
                        <div id="deliveryDates" #delivery>
                           <div>Delivery</div>
                           <ng-container *ngIf="shipment.ddatefrom">{{shipment.ddatefrom | date}}</ng-container>
                           <ng-container *ngIf="shipment.ddatefrom && shipment.ddateto"> - </ng-container>
                           <ng-container *ngIf="shipment.ddateto">{{shipment.ddateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="shipment.dtimefrom">{{shipment.dtimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="shipment.dtimefrom && shipment.dtimeto"> - </ng-container>
                           <ng-container *ngIf="shipment.dtimeto">{{shipment.dtimeto | time : 'h:mm A'}}</ng-container>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="itemCalculator" class="bordered" expanded *ngIf="shipment.containers?.length || shipment.calculator?.length">
                     <mat-expansion-panel-header>
                        Item Calculator
                     </mat-expansion-panel-header>
   
                     <div id="itemsType" class="flex" *ngIf="shipment.itemsType">
                        <div id="shippingType" *ngIf="shipment.shippingType">
                           <div>Shipping type</div>
                           {{shipment.shippingType}}
                        </div>
   
                        <div class="hr"></div>
                     </div>
   
                     <ng-container *ngIf="shipment.calculator && shipment.calculator.length">
                        <div class="flex">
                           <div id="calculator" *ngFor="let calc of shipment.calculator; let i = index" class="calc">
                              <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                           </div>
                        </div>
   
                        <div class="hr"></div>
                     </ng-container>
   
                     <ng-container *ngIf="shipment.containers && shipment.containers.length">
                        <div  id="container" *ngFor="let container of shipment.containers; let i = index">
                           <div class="header" color="primary" class="common-mb1em common-bold">Container {{i + 1}}</div>
   
                           <div class="flex">
                              <div *ngIf="container.number">
                                 <div id="containerNumberLabel">Container Number</div>
                                 <div id="containerNumber">{{container.number}}</div>
                              </div>
   
                              <div>
                                 <div id="containerTypeLabel">Container Type</div>
                                 <div id="containerType">{{container.type}}</div>
                              </div>
   
                              <div *ngIf="container.sealNumber">
                                 <div id="sealNumberLabel">Seal Number</div>
                                 <div id="sealNumber">{{container.sealNumber}}</div>
                              </div>
                           </div>
   
                           <div class="flex">
                              <div id="containerItem" *ngFor="let calc of container.items; let i = index" class="calc">
                                 <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                              </div>
                           </div>
   
                           <div class="hr"></div>
                        </div>
                     </ng-container>
   
                     <ng-template #calcDetails let-calc="calc" let-i="i">
                        <div>Item {{i+1}}</div>
                        <span id="calcPieces" color="primary" class="common-inlineblock common-w17ex">Pieces </span>{{calc.pieces}}<br/>
                        <span id="calcWeight" color="primary" class="common-inlineblock common-w17ex">Weight </span>{{[calc] | totaldualweight}}<br/>
                        <ng-container *ngIf='calc.length && calc.width && calc.height && calc.measure_type'>
                           <span id="calcDimensions" color="primary" class="common-inlineblock common-w17ex">Dimensions </span>{{calc.length}} x {{calc.width}} x {{calc.height}} {{calc.measure_type}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.description">
                           <span id="calcDescription" color="primary" class="common-inlineblock common-w17ex">Item Description </span>{{calc.description}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.reference">
                           <span id="calcReference" color="primary" class="common-inlineblock common-w17ex">Item Reference </span>{{calc.reference}}<br/>
                        </ng-container>
                     </ng-template>
   
                     <div class="flex" *ngIf="items$ | async as items">
                        <div>
                           <div id="totalPiecesLabel">Total Pieces</div>
                           <div id="totalPieces">{{items | total : 'pieces' | number}}</div>
                        </div>
   
                        <div>
                           <div id="totalWeightLabel">Total Weight</div>
                           <div id="totalWeight">{{items | totaldualweight }}</div>
                        </div>
   
                        <div *ngIf="items | totalvolume">
                           <div id="volumeLabel">Volume</div>
                           <div id="volume">{{items | totaldualvolume }}</div>
                        </div>
   
                        <div *ngIf="shipment.containers?.length">
                           <div id="totalContainersLabel">Total Containers</div>
                           <div id="totalContainers">{{shipment.containers.length}}</div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="referenceDetails" class="bordered" expanded *ngIf="shipment.references?.length">
                     <mat-expansion-panel-header>
                        Reference Details
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'party', 'type', 'data' ] as columns">
                        <mat-table id="referenceTable" [dataSource]="shipment.references" class="rotate-cdk-table">
                           <ng-container matColumnDef="party">
                              <mat-header-cell id="referencePartyHeader" *matHeaderCellDef>Party</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="referencPartyLabel" class="header">Party</div>
                                 <div id="referenceParty" class="cell">{{row.party | spacers | titlecase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="type">
                              <mat-header-cell id="referenceTypeHeader" *matHeaderCellDef>Type</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="referenceTypeLabel"class="header">Type</div>
                                 <div id="referenceType" class="cell">{{row.type | uppercase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="data">
                              <mat-header-cell id="referenceNumberHeader" *matHeaderCellDef class="common-fg2">Reference Number</mat-header-cell>
                              <mat-cell *matCellDef="let row" class="common-fg2">
                              <div id="referenceNumberLabel" class="header">Reference Number</div>
                              <div id="referenceNumber" class="cell">{{row.data}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="tradeshowDetails" class="bordered" expanded *ngIf="shipment.tradeshow?.length">
                     <mat-expansion-panel-header>
                        Tradeshow Details
                     </mat-expansion-panel-header>
                     <div id="tradeshow" class="flex">
                        <div *ngFor="let t of shipment.tradeshow">
                           <div>{{t.location | titlecase}}</div>
                           <span id="tradeshowName" color="primary" class="common-inlineblock common-w15ex">Show Name </span>{{t.name}}<br/>
                           <span id="tradeshowBooth" color="primary" class="common-inlineblock common-w15ex">Booth Number </span>{{t.booth}}<br/>
                           <span id="tradeshowExhibitor" color="primary" class="common-inlineblock common-w15ex">Exhibitor </span>{{t.exhibitor}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="riskDetails" class="bordered" expanded *ngIf="shipment.risks">
                     <mat-expansion-panel-header>
                        Risks
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div id="riskType">
                           <div>Risk Type</div>
                           {{(shipment.risks.type | spacers | titlecase) || 'None'}}
                        </div>
                        <div id="riskAmount" *ngIf="shipment.risks && shipment.risks.amount">
                           <div>Amount</div>
                           {{shipment.risks.amount | currencycode: shipment.risks.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="descriptionInstructions" class="bordered" expanded *ngIf="shipment.description || shipment.specialinstructions || (shipment.cod && shipment.cod.amount)">
                     <mat-expansion-panel-header>
                        Description and Instructions
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <ng-container *ngIf="shipment.cod && shipment.cod.type">
                           <div id="cod" *ngIf="shipment.cod as cod">
                              <div>COD</div>
                              {{cod.type | titlecase}} {{cod.amount | currencycode: cod.currency}}
                           </div>
                        </ng-container>
   
                        <div class="full" #description *ngIf="shipment.description">
                           <div>Shipment Description</div>
                           <div id="description" class="wordwrap">
                              {{shipment.description}}
                           </div>
                        </div>
   
                        <div class="full" #specialinstuctions *ngIf="shipment.specialinstructions">
                           <div>Special Instructions</div>
                           <div id="specialInstructions" class="wordwrap">
                              {{shipment.specialinstructions}}
                           </div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="podDetails" class="bordered" expanded *ngIf="shipment.pod">
                     <mat-expansion-panel-header>
                        POD Information
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <div id="podDate" *ngIf="shipment.pod.date">
                           <div>POD Date</div>
                           {{shipment.pod.date | date}}
                        </div>
   
                        <div id="podTime" *ngIf="shipment.pod.time">
                           <div>POD Time</div>
                           {{shipment.pod.time | time : 'h:mm A'}} {{shipment.pod.timezone}}
                        </div>
   
                        <div id="podSigned" *ngIf="shipment.pod.name">
                           <div>Signed</div>
                           {{shipment.pod.name}}
                        </div>
   
                        <div id="podPieces" *ngIf="shipment.pod.pieces">
                           <div>Pieces</div>
                           {{shipment.pod.pieces}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="customsDetails" class="bordered" expanded *ngIf="shipment.customs">
                     <mat-expansion-panel-header>Customs Details</mat-expansion-panel-header>
   
                     <div class="flex">
                        <div id="goodsValue" *ngIf="shipment.customs.value">
                           <div>Goods Value</div>
                           {{shipment.customs.value | currencycode: shipment.customs.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <ng-container id="attachments" *ngIf="shipment.attachments?.length || allowNewAttachments">
                     <br/>
                     <lib-attachment-display
                     [attachments]="shipment.attachments || []"
                     [attachmentTypesEnum]="enums.attachmentTypes(shipment.shipType, shipment.mode)"
                     [updateForm]="attachmentUpdates"
                     [allowNewAttachments]="allowNewAttachments"
   
                     (save)="saveAttachments( shipment.hawb, $event )"
                  ></lib-attachment-display>
                  </ng-container>
               </div>
   
               <div class="tracking common-mt1em" *ngIf="shipment.statuses?.length">
                  <h2 id="" color="primary">Tracking</h2>
   
                  <mat-table id="trackingTable" [dataSource]="getSortedStatusesById( shipment.statuses )" class="rotate-cdk-table">
                     <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                           <div id="trackingDateHeader" class="header">Date</div>
                           <div id="trackingDate" class="cell">{{row.date | date: 'mediumDate'}}</div>
                        </mat-cell>
                     </ng-container>
   
                     <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef class="common-fg3">Status</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="common-fg3">
                           <div id="trackingStatusHeader" class="header">Status</div>
                           <div id="trackingStatus" class="cell">
                              {{ row.event ? row.event : row.status }}
                              <ng-container *ngIf="row.reason">
                                 <br/>
                                 {{row.reason}}
                              </ng-container>
                           </div>
                        </mat-cell>
                     </ng-container>

                     <ng-container matColumnDef="location">
                        <mat-header-cell *matHeaderCellDef class="common-fg3">Location</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="common-fg3">
                           <div id="trackingLocationHeader" class="header">Location</div>
                           <div id="trackingLocation" class="cell">{{row.location}}</div>
                        </mat-cell>
                     </ng-container>
   
                     <mat-header-row *matHeaderRowDef="[ 'date', 'status', 'location' ]"></mat-header-row>
                     <mat-row *matRowDef="let row; columns: [ 'date', 'status', 'location' ]"></mat-row>
                  </mat-table>
               </div>
            </div>
         </ng-container>
      </ng-container>
   </ng-container>
   <ng-container *ngIf="mode === 'quote'">
      <ng-container *ngIf="quotation$ | async as quotation; else loading">
         <ng-container *ngIf="quotation; else invalid">
            <div id="quoteDetails" class="quotation-details">
               <h2 id="requestDetails" color="primary">Quotation Request Details</h2>

               <div id="quotationNumber" class="service-label">Request #{{ quotation.fwq }}</div>

               <div id="qSummary" class="summary">
                  <div class="list summary-details">
                     <ng-container *ngIf="quotation.serviceLevel">
                        <header id="qSummaryServiceLevel" color="primary">Service Level</header>
                        <span id=""> {{ quotation.serviceLevel }}<br/></span>
                     </ng-container>
   
                     <ng-container *ngIf="items$ | async as items">
                        <header id="qSummaryTotalPiecesLabel" color="primary">Total Pieces</header>
                        <span id="qSummaryTotalPieces"> {{items | total : 'pieces' | number}}<br/></span>
   
                        <header id="qSummaryTotalWeightLabel" color="primary">Total Weight</header>
                        <span id="qSummaryTotalWeight"> {{items | totaldualweight }}<br/></span>
   
                        <ng-container *ngIf="items | totalvolume">
                           <header id="qSummaryTotalVolumeLabel" color="primary">Volume</header>
                           <span id="qSummaryTotalVolume"> {{items | totaldualvolume }}<br/></span>
                        </ng-container>
                        
                        <ng-container *ngIf="quotation.milestones?.ready">
                           <header id="qSummaryTotalCostLabel" color="primary">Total Cost</header>
                           <span id="qSummaryTotalCost"> {{ quotation.cost | currencycode : quotation.costCurrency }}<br/></span>
                        </ng-container>
                     </ng-container>
   
                     <ng-container *ngIf="getBillingPartyRef( quotation ) as ref">
                        <header id="qSummaryReferenceNumberLabel" color="primary">Ref #</header>
                        <span id="qSummaryReferenceNumber">
                           <ng-container *ngIf="ref.type">{{ref.type | uppercase}} - </ng-container>
                           {{ref.data}}<br/>
                        </span>
                     </ng-container>
                  </div>
   
                  <div id="qSummaryShipper" class="summary-shipper">
                     <b id="qSummaryShipperLabel" color="primary">Shipper</b><br/>
                     <ng-container *ngIf="quotation.shipper.name || quotation.shipper.city">
                        {{ quotation.shipper.name }}{{ quotation.shipper.name && quotation.shipper.city ? ', ' : '' }}{{ quotation.shipper.city }}<br />
                     </ng-container>
                     Pickup Date
                     <ng-container *ngIf="quotation.pdatefrom">{{quotation.pdatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="quotation.pdatefrom && quotation.pdateto"> - </ng-container>
                     <ng-container *ngIf="quotation.pdateto">{{quotation.pdateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Pickup Time
                     <ng-container *ngIf="quotation.ptimefrom">{{quotation.ptimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="quotation.ptimefrom && quotation.ptimeto"> - </ng-container>
                     <ng-container *ngIf="quotation.ptimeto">{{quotation.ptimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <div id="qSummaryConsingee" class="summary-consignee">
                     <b id="qSummaryConsingeeLabel" color="primary">Consignee</b><br/>
                     <ng-container *ngIf="quotation.consignee.name || quotation.consignee.city">
                        {{ quotation.consignee.name }}{{ quotation.consignee.name && quotation.consignee.city ? ', ' : '' }}{{ quotation.consignee.city }}<br />
                     </ng-container>
                     Delivery Date
                     <ng-container *ngIf="quotation.ddatefrom">{{quotation.ddatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="quotation.ddatefrom && quotation.ddateto"> - </ng-container>
                     <ng-container *ngIf="quotation.ddateto">{{quotation.ddateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Delivery Time
                     <ng-container *ngIf="quotation.dtimefrom">{{quotation.dtimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="quotation.dtimefrom && quotation.dtimeto"> - </ng-container>
                     <ng-container *ngIf="quotation.dtimeto">{{quotation.dtimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>

                  <div id="qSummaryBillTo" class="summary-bill-to">
                     <b id="qSummaryBillToLabel" color="primary">Bill To</b><br/>
                     {{quotation.bill_to.name}}<br/>
                     {{quotation.bill_to.address1}}<br/>
                     {{quotation.bill_to.address2}}<br/>
                     <ng-container *ngIf="quotation.bill_to.address3">{{quotation.bill_to.address3}}<br/></ng-container>
                     {{quotation.bill_to.city}}, {{quotation.bill_to.state}} {{quotation.bill_to.postalcode}}<br/>
                     {{quotation.bill_to.country}}
                     <br/>
                  </div>
   
                  <ng-container *ngIf="quotation.station as station">
                     <div id="" class="summary-station">
                        <b id="" color="primary">Station</b><br/>
                        {{station.name}}<br/>
                        {{station.address1}}<br/>
                        <ng-container *ngIf="station.address2">{{station.address2}}<br/></ng-container>
                        {{station.city}}, {{station.state}} {{station.postalcode}}<br/>
                        <ng-container *ngIf="station.country">{{ countries.countryName( station.country ) | async }}<br/></ng-container>
                        <ng-container *ngIf="station.phone || station.email">
   
                           <br/>
                           <ng-container *ngIf="station.phone">{{station.phone}}<br/></ng-container>
                           <ng-container *ngIf="station.email">{{station.email}}<br/></ng-container>
                        </ng-container>
                     </div>
                  </ng-container>

                  <div id="qSummaryDate" class="summary-dates">
                     <b id="qSummaryCreateDateLabel" color="primary">Create Date</b><br/>
                     <ng-container *ngIf="quotation.createdDate">{{ quotation.createdDate }}</ng-container><br/><br/>
                     <b id="qValidityDateLabel" color="primary">Validity Date</b><br/>
                     {{ quotation.validToDate | utcToLocal: quotation.validToTime }}<br/><br/>
                     <b id="qQuotationNumberLabel" color="primary">Quotation #</b><br/>
                     {{ quotation.fwq }}<br/>
                  </div>
               </div>
               
               <lib-quote-tracker-line [mode]="[quotation.mode]" [milestoneObj]="quotation.milestones" [quotePage]="true" (quoteStatus)="quoteStatus=$event"></lib-quote-tracker-line>

               <div class="details">
                  <mat-expansion-panel id="qBookingDetails" class="bordered" expanded>
                     <mat-expansion-panel-header>Booking Details</mat-expansion-panel-header>
                     <!-- Ocean Layout -->
                     <div class="booking-details-grid ocean-grid" *ngIf="quotation.mode === 'ocean'">
                        <div class="column">
                           <div *ngIf="quotation.quoteType">
                              <header color="primary">Type</header>
                              <span>{{quotation.quoteType | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.mode">
                              <header color="primary">Mode</header>
                              <span>{{quotation.mode | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.trafficDirection">
                              <header color="primary">Traffic Direction</header>
                              <span>{{quotation.trafficDirection | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.movementType">
                              <header color="primary">Movement Type</header>
                              <span>{{quotation.movementType.from | titlecase}} to {{quotation.movementType.to | titlecase}}</span>
                           </div>
                        </div>
                        <div class="column">
                           <div *ngIf="quotation.origin">
                              <header color="primary">Origin Port</header>
                              <span>{{quotation.origin | uppercase}}</span>
                           </div>
                           <div *ngIf="quotation.destination">
                              <header color="primary">Destination Port</header>
                              <span>{{quotation.destination | uppercase}}</span>
                           </div>
                        </div>
                        <div class="column">
                        </div>
                     </div>
                     <!-- Domestic Layout -->
                     <div class="booking-details-grid domestic-grid" *ngIf="quotation.quoteType === 'domestic'">
                        <div class="column">
                           <div *ngIf="quotation.quoteType">
                              <header color="primary">Type</header>
                              <span>{{quotation.quoteType | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.mode">
                              <header color="primary">Mode</header>
                              <span>{{quotation.mode | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.trafficDirection">
                              <header color="primary">Traffic Direction</header>
                              <span>{{quotation.trafficDirection | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.movementType">
                              <header color="primary">Movement Type</header>
                              <span>{{quotation.movementType.from | titlecase}} to {{quotation.movementType.to | titlecase}}</span>
                           </div>
                        </div>
                        <div class="column">
                           <div *ngIf="quotation.airportfrom">
                              <header color="primary">Origin Airport</header>
                              <span>{{quotation.airportfrom | uppercase}}</span>
                           </div>
                           <div *ngIf="quotation.airportto">
                              <header color="primary">Destination Airport</header>
                              <span>{{quotation.airportto | uppercase}}</span>
                           </div>
                        </div>
                     </div>
                     <!-- INTL Air Layout -->
                     <div class="booking-details-grid intl-air-grid" *ngIf="quotation.quoteType === 'international' && quotation.mode === 'air'">
                        <div class="column">
                           <div *ngIf="quotation.quoteType">
                              <header color="primary">Type</header>
                              <span>{{quotation.quoteType | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.mode">
                              <header color="primary">Mode</header>
                              <span>{{quotation.mode | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.trafficDirection">
                              <header color="primary">Traffic Direction</header>
                              <span>{{quotation.trafficDirection | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.movementType">
                              <header color="primary">Movement Type</header>
                              <span>{{quotation.movementType.from | titlecase}} to {{quotation.movementType.to | titlecase}}</span>
                           </div>
                        </div>
                        <div class="column">
                           <div *ngIf="quotation.airportfrom">
                              <header color="primary">Origin Airport</header>
                              <span>{{quotation.airportfrom | uppercase}}</span>
                           </div>
                           <div *ngIf="quotation.airportto">
                              <header color="primary">Destination Airport</header>
                              <span>{{quotation.airportto | uppercase}}</span>
                           </div>
                        </div>
                     </div>
                     <!-- INTL Road Layout -->
                     <div class="booking-details-grid intl-air-grid" *ngIf="quotation.quoteType === 'international' && quotation.mode === 'road'">
                        <div class="column">
                           <div *ngIf="quotation.quoteType">
                              <header color="primary">Type</header>
                              <span>{{quotation.quoteType | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.mode">
                              <header color="primary">Mode</header>
                              <span>{{quotation.mode | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.trafficDirection">
                              <header color="primary">Traffic Direction</header>
                              <span>{{quotation.trafficDirection | titlecase}}</span>
                           </div>
                           <div *ngIf="quotation.movementType">
                              <header color="primary">Movement Type</header>
                              <span>{{quotation.movementType.from | titlecase}} to {{quotation.movementType.to | titlecase}}</span>
                           </div>
                        </div>
                        <div class="column">
                           <div *ngIf="quotation.airportfrom">
                              <header color="primary">Origin Airport</header>
                              <span>{{quotation.airportfrom | uppercase}}</span>
                           </div>
                           <div *ngIf="quotation.airportto">
                              <header color="primary">Destination Airport</header>
                              <span>{{quotation.airportto | uppercase}}</span>
                           </div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <div id="qPartyCard" class="party-card">
                     <ng-container *ngFor="let party of [ 'shipper', 'consignee', 'bill_to' ]">
                        <mat-expansion-panel [id]="'q'+party+'Party'" [class]="'mat-expansion-panel bordered ' + party" expanded hideToggle *ngIf="quotation[party] as data">
                           <mat-expansion-panel-header>{{party | spacers | titlecase}}</mat-expansion-panel-header>
                           <div id="qPartyContent" class="content">
                              <ng-container *ngIf="data.name">{{data.name}}<br/></ng-container>
                              <ng-container *ngIf="data.address1">{{data.address1}}<br/></ng-container>
                              <ng-container *ngIf="data.address2">{{data.address2}}<br/></ng-container>
                              <ng-container *ngIf="data.address3">{{data.address3}}<br/></ng-container>
                              <ng-container *ngIf="data.city || data.state || data.postalcode">
                                 {{data.city}}{{ data.city && ( data.state || data.postalcode ) ? ', ' : '' }}{{data.state}} {{data.postalcode}}<br/>
                              </ng-container>
                              <ng-container *ngIf="data.country">{{ countries.countryName( data.country ) | async }}<br/></ng-container>
                              <br *ngIf="data.phone || data.email" />
                              <ng-container *ngIf="data.phone">{{data.phone}}<br/></ng-container>
                              <ng-container *ngIf="data.email">
                                 <a id="qPartyEmail" href="mailto:{{data.email}}" color="accent" class="common-tdnone">{{data.email}}<br/></a>
                              </ng-container>
                              <ng-container *ngIf="data.contact as contact">
                                 <br *ngIf="contact.name || contact.phone || contact.email" />
                                 <ng-container *ngIf="contact.name">{{contact.name}}<br/></ng-container>
                                 <ng-container *ngIf="contact.phone">{{contact.phone}}<br/></ng-container>
                                 <ng-container *ngIf="contact.email">
                                    <a id="qContactEmail" href="mailto:{{contact.email}}" color="accent" class="common-tdnone">{{contact.email}}</a>
                                 </ng-container>
                              </ng-container>
                           </div>
                        </mat-expansion-panel>
                     </ng-container>
                  </div>
   
                  <mat-expansion-panel id="qServiceLevelDates" class="bordered" expanded>
                     <mat-expansion-panel-header>
                        Service Level and Dates
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div id="qServiceLevel" *ngIf="quotation.serviceLevel">
                           <div>Service Level</div>
                           {{ quotation.serviceLevel }}
                        </div>
   
                        <div id="qIntercoms" *ngIf="quotation.incoterms">
                           <div>Incoterms</div>
                           {{quotation.incoterms}}
                        </div>

                        <div id="qAccessorials" class="accessorials-container" *ngIf="quotation.accessorials && quotation.accessorials.length">
                           <div>Accessorials</div>
                           <span
                             #textContent
                             class="accessorials-text">
                             {{ getAccessorial(quotation.accessorials , expanded) | titlecase}}
                             <span *ngIf="!expanded && showToggle" class="more-toggle" (click)="expanded = true">{{ ' + '+ remainingAccessorials +' More'}}</span>
                           </span>
                         </div>
   
                        <div id="qAwbType" *ngIf="quotation.awbType">
                           <div>AWB Type</div>
                           {{quotation.awbType}}
                        </div>
   
                        <!-- <div *ngIf="quotation.teu">
                           <div>Number of TEU</div>
                           {{quotation.teu}}
                        </div> -->
   
                        <div class="hr"></div>
   
                        <div id="qPickupDates" #pickup>
                           <div>Pickup</div>
                           <ng-container *ngIf="quotation.pdatefrom">{{quotation.pdatefrom | date}}</ng-container>
                           <ng-container *ngIf="quotation.pdatefrom && quotation.pdateto"> - </ng-container>
                           <ng-container *ngIf="quotation.pdateto">{{quotation.pdateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="quotation.ptimefrom">{{quotation.ptimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="quotation.ptimefrom && quotation.ptimeto"> - </ng-container>
                           <ng-container *ngIf="quotation.ptimeto">{{quotation.ptimeto | time : 'h:mm A'}}</ng-container>
                        </div>
   
                        <div id="qDeliveryDates"#delivery>
                           <div>Delivery</div>
                           <ng-container *ngIf="quotation.ddatefrom">{{quotation.ddatefrom | date}}</ng-container>
                           <ng-container *ngIf="quotation.ddatefrom && quotation.ddateto"> - </ng-container>
                           <ng-container *ngIf="quotation.ddateto">{{quotation.ddateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="quotation.dtimefrom">{{quotation.dtimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="quotation.dtimefrom && quotation.dtimeto"> - </ng-container>
                           <ng-container *ngIf="quotation.dtimeto">{{quotation.dtimeto | time : 'h:mm A'}}</ng-container>
                        </div>
                     </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel id="qChargesDetails" class="bordered" expanded *ngIf="quoteStatus?.code.toLowerCase()!='submitted' && quotation.charges?.chargeItems">
                     <mat-expansion-panel-header>
                        Charges
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'description', 'quantity', 'rate', 'amount' ] as columns">
                        <mat-table id="qChargesTable" [dataSource]="quotation.charges?.chargeItems" class="rotate-cdk-table">
                           <ng-container matColumnDef="description">
                              <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qChargesDescriptionLabel" class="header">Description</div>
                                 <div id="qChargesDescription" class="cell">{{row.chargeDescription | spacers | titlecase}}</div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="quantity">
                              <mat-header-cell *matHeaderCellDef>Quantity</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qChargesQuantityLabel" class="header">Quantity</div>
                              <div id="qChargesQuantity" class="cell">{{row.chargeQuantity }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                           </ng-container>

                           <ng-container matColumnDef="rate">
                              <mat-header-cell *matHeaderCellDef>Rate</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qChargesRateLabel" class="header">Rate</div>
                              <div id="qChargesRate" class="cell">{{ +row.chargeRate | tofixed : 2 }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef>Total Due</mat-footer-cell>
                           </ng-container>

                           <ng-container matColumnDef="amount">
                              <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qChargesAmountLabel" class="header">Amount</div>
                              <div id="qChargesAmount" class="cell">{{row.chargeCodeAmount | currencycode : row.chargeCodeCurrency }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef> {{ quotation.charges.totalCharges | currencycode : quotation.charges.totalChargesCurrency }}</mat-footer-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                           <mat-footer-row *matFooterRowDef="columns"></mat-footer-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="qItemCalculator" class="bordered" expanded *ngIf="quotation.containers?.length || quotation.calculator?.length">
                     <mat-expansion-panel-header>
                        Item Calculator
                     </mat-expansion-panel-header>
   
                     <div id="qItemsType" class="flex" *ngIf="quotation.itemsType">
                        <div id="qShippingType" *ngIf="quotation.shippingType">
                           <div>Shipping type</div>
                           {{quotation.shippingType}}
                        </div>
   
                        <div class="hr"></div>
                     </div>
   
                     <ng-container *ngIf="quotation.calculator && quotation.calculator.length">
                        <div class="flex">
                           <div id="qCalculator" *ngFor="let calc of quotation.calculator; let i = index" class="calc">
                              <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                           </div>
                        </div>
   
                        <div class="hr"></div>
                     </ng-container>
   
                     <ng-container *ngIf="quotation.containers && quotation.containers.length">
                        <div id="qContainer" *ngFor="let container of quotation.containers; let i = index">
                           <div class="header" color="primary" class="common-mb1em common-bold">Container {{i + 1}}</div>
   
                           <div class="flex">
                              <div *ngIf="container.number">
                                 <div id="qContainerNumberLabel">Container Number</div>
                                 <div id="qContainerNumber">{{container.number}}</div>
                              </div>
   
                              <div>
                                 <div id="qContainerTypeLabel">Container Type</div>
                                 <div id="qContainerType">{{container.type}}</div>
                              </div>
   
                              <div *ngIf="container.sealNumber">
                                 <div id="qSealNumberLabel">Seal Number</div>
                                 <div id="qSealNumber">{{container.sealNumber}}</div>
                              </div>
                           </div>
   
                           <div class="flex">
                              <div id="qContainerItem"*ngFor="let calc of container.items; let i = index" class="calc">
                                 <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                              </div>
                           </div>
   
                           <div class="hr"></div>
                        </div>
                     </ng-container>
   
                     <ng-template #calcDetails let-calc="calc" let-i="i">
                        <div>Item {{i+1}}</div>
                        <span id="qCalcPieces" color="primary" class="common-inlineblock common-w17ex">Pieces </span>{{calc.pieces}}<br/>
                        <span id="qCalcWeight" color="primary" class="common-inlineblock common-w17ex">Weight </span>{{[calc] | totaldualweight}}<br/>
                        <ng-container *ngIf='calc.length && calc.width && calc.height && calc.measure_type'>
                           <span id="qCalcDimensions" color="primary" class="common-inlineblock common-w17ex">Dimensions </span>{{calc.length}} x {{calc.width}} x {{calc.height}} {{calc.measure_type}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.description">
                           <span id="qCalcDescription" color="primary" class="common-inlineblock common-w17ex">Item Description </span>{{calc.description}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.reference">
                           <span id="qCalcReference" color="primary" class="common-inlineblock common-w17ex">Item Reference </span>{{calc.reference}}<br/>
                        </ng-container>
                     </ng-template>
   
                     <div class="flex" *ngIf="items$ | async as items">
                        <div>
                           <div id="qTotalPiecesLabel">Total Pieces</div>
                           <div id="qTotalPieces">{{items | total : 'pieces' | number}}</div>
                        </div>
   
                        <div>
                           <div id="qTotalWeightLabel">Total Weight</div>
                           <div id="qTotalWeight">{{items | totaldualweight }}</div>
                        </div>
   
                        <div *ngIf="items | totalvolume">
                           <div id="qVolumeLabel">Volume</div>
                           <div id="qVolume">{{items | totaldualvolume }}</div>
                        </div>
   
                        <div *ngIf="quotation.containers?.length">
                           <div id="qTotalContainersLabel">Total Containers</div>
                           <div id="qTotalContainers">{{quotation.containers.length}}</div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="qReferenceDetails" class="bordered" expanded *ngIf="quotation.references?.length">
                     <mat-expansion-panel-header>
                        Reference Details
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'party', 'type', 'data' ] as columns">
                        <mat-table id="" [dataSource]="quotation.references" class="rotate-cdk-table">
                           <ng-container matColumnDef="party">
                              <mat-header-cell *matHeaderCellDef>Party</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qReferencPartyLabel" class="header">Party</div>
                                 <div id="qReferenceParty" class="cell">{{row.party | spacers | titlecase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="type">
                              <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div id="qReferenceTypeLabel" class="header">Type</div>
                              <div id="qReferenceType" class="cell">{{row.type | uppercase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="data">
                              <mat-header-cell *matHeaderCellDef class="common-fg2">Reference Number</mat-header-cell>
                              <mat-cell *matCellDef="let row" class="common-fg2">
                              <div id="qReferenceNumberLabel" class="header">Reference Number</div>
                              <div id="qReferenceNumber" class="cell">{{row.data}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="qTradeshowDetails" class="bordered" expanded *ngIf="quotation.tradeshow?.length">
                     <mat-expansion-panel-header>
                        Tradeshow Details
                     </mat-expansion-panel-header>
                     <div id="qTradeshow" class="flex">
                        <div *ngFor="let t of quotation.tradeshow">
                           <div>{{t.location | titlecase}}</div>
                           <span id="qTradeshowName" color="primary" class="common-inlineblock common-w15ex">Show Name </span>{{t.name}}<br/>
                           <span id="qTradeshowBooth" color="primary" class="common-inlineblock common-w15ex">Booth Number </span>{{t.booth}}<br/>
                           <span id="qTradeshowExhibitor" color="primary" class="common-inlineblock common-w15ex">Exhibitor </span>{{t.exhibitor}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="qRiskDetails" class="bordered" expanded *ngIf="quotation.risks">
                     <mat-expansion-panel-header>
                        Risks
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div id="qRiskType">
                           <div>Risk Type</div>
                           {{(quotation.risks.type | spacers | titlecase) || 'None'}}
                        </div>
                        <div id="qRiskAmount" *ngIf="quotation.risks && quotation.risks.amount">
                           <div>Amount</div>
                           {{quotation.risks.amount | currencycode: quotation.risks.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel id="qDescriptionInstructions" class="bordered" expanded *ngIf="quotation.description || quotation.specialinstructions || (quotation.cod && quotation.cod.amount)">
                     <mat-expansion-panel-header>
                        Description and Instructions
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <ng-container *ngIf="quotation.cod && quotation.cod.type">
                           <div id="qCod" *ngIf="quotation.cod as cod">
                              <div>COD</div>
                              {{cod.type | titlecase}} {{cod.amount | currencycode: cod.currency}}
                           </div>
                        </ng-container>
   
                        <div class="full" #description *ngIf="quotation.description">
                           <div>Quotation Description</div>
                           <div id="qDescription" class="wordwrap">
                              {{quotation.description}}
                           </div>
                        </div>
   
                        <div class="full" #specialinstuctions *ngIf="quotation.specialinstructions">
                           <div>Special Instructions</div>
                           <div id="qSpecialInstructions" class="wordwrap">
                              {{quotation.specialinstructions}}
                           </div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <!-- <mat-expansion-panel class="bordered" expanded *ngIf="quotation.pod">
                     <mat-expansion-panel-header>
                        POD Information
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="quotation.pod.date">
                           <div>POD Date</div>
                           {{quotation.pod.date | date}}
                        </div>
   
                        <div *ngIf="quotation.pod.time">
                           <div>POD Time</div>
                           {{quotation.pod.time | time : 'h:mm A'}} {{quotation.pod.timezone}}
                        </div>
   
                        <div *ngIf="quotation.pod.name">
                           <div>Signed</div>
                           {{quotation.pod.name}}
                        </div>
   
                        <div *ngIf="quotation.pod.pieces">
                           <div>Pieces</div>
                           {{quotation.pod.pieces}}
                        </div>
                     </div>
                  </mat-expansion-panel> -->
   
                  <!-- <mat-expansion-panel class="bordered" expanded *ngIf="quotation.customs">
                     <mat-expansion-panel-header>Customs Details</mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="quotation.customs.value">
                           <div>Goods Value</div>
                           {{quotation.customs.value | currencycode: quotation.customs.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel> -->
   
                  <ng-container id="qAttachments" *ngIf="quotation.attachments?.length || allowNewAttachments">
                     <br/>
                     <lib-attachment-display
                     [attachments]="quotation.attachments || []"
                     [attachmentTypesEnum]="enums.attachmentTypes(quotation.quoteType, quotation.mode)"
                     [updateForm]="attachmentUpdates"
                     [allowNewAttachments]="allowNewAttachments"
   
                     (save)="saveQuoteAttachments( quotation.fwq, $event )"
                  ></lib-attachment-display>
                  </ng-container>
               </div>
            </div>
         </ng-container>
      </ng-container>
   </ng-container>
</ng-container>
